module.exports = __webpack_public_path__ + "static/media/TNCDigital_Web_Cercador_1.72d13f50.svg";